export const CHECKOUT_URL = 'https://metodo-para-padres-de-futbolistas-latam.impultienda.ar/checkout';
export const stats = [{
  value: "5 +2",
  label: "Módulos y Bonos"
}, {
  value: '+200',
  label: 'Páginas en PDF'
}, {
  value: '100%',
  label: 'Material digital'
}, {
  value: "∞",
  label: 'Acceso de por vida'
}];
export const heroTestimonials = [{
  quote: 'Antes no entendía nada de clubes, representantes ni permisos. Cuando una academia nos hizo una oferta, ya sabía qué preguntar, qué pedir por escrito y qué no aceptar.',
  name: 'Alejandro M.',
  role: 'Papá de futbolista sub-16'
}, {
  quote: 'Nos contactó un supuesto representante y no lográbamos verificar si era real. El método nos dio un orden claro para revisar todo y también para acompañar a mi hijo sin sumarle presión.',
  name: 'Carolina R.',
  role: 'Mamá de futbolista sub-15'
}];
export const problems = ['Tu hijo o hija no está jugando y no sabes cómo conversarlo con el club, ni cuándo conviene buscar otra institución.', 'Aparecen "scouts" o representantes y no tienes forma de verificar si están habilitados ante la federación correspondiente.', 'Te presentan un contrato o una carta de compromiso y no sabes qué cláusulas revisar antes de firmar.', 'Llega una "oportunidad" fuera del país y no distingues si es real o si se trata de una estafa.', 'Desconoces qué derechos tiene un jugador menor de edad según el país y la normativa vigente.', 'Quieres acompañar la carrera de tu hijo o hija, pero no sabes por dónde empezar ni qué decisiones tomar primero.'];
export const chapters = [{
  number: '01',
  title: 'Cómo funciona el fútbol juvenil',
  description: 'Entiende quién es quién: clubes, academias, federaciones, ligas, scouts y agentes. Cómo se organiza el camino formativo y cuál es el rol real de padres y madres en cada etapa, de los 8 a los 18 años.',
  tags: ['Clubes y academias', 'Federaciones y ligas', 'Etapas del jugador', 'Rol de la familia']
}, {
  number: '02',
  title: 'Legalidad: contratos, representantes y todo por escrito',
  description: 'Reglas FIFA/RSTP y de la federación correspondiente explicadas en lenguaje simple. Cómo detectar scouts falsos, pruebas falsas y representantes sin licencia, qué cláusulas leer con calma, por qué todo acuerdo debe quedar por escrito y en qué momento conviene consultar a un abogado especializado en derecho deportivo.',
  tags: ['FIFA / RSTP', 'Cláusulas clave', 'Representantes sin licencia', 'Todo por escrito']
}, {
  number: '03',
  title: 'Visibilidad: que el talento se vea y llegue a quien decide',
  description: 'Cómo construir visibilidad real: video de jugadas bien editado, CV deportivo, uso responsable de redes, calendario de torneos y contactos verificados. Incluye cómo preparar una estrategia de exposición ante scouts y cómo evaluar rutas hacia otras ligas, paso a paso.',
  tags: ['Video y CV deportivo', 'Calendario de torneos', 'Contactos verificados', 'Estrategia con scouts']
}, {
  number: '04',
  title: 'Biología y mente: rendimiento sostenible sin quiebres',
  description: 'Maduración biológica, carga de entrenamiento, descanso, nutrición y prevención de lesiones a nivel educativo. Además, cómo acompañar emocionalmente sin convertirte en una fuente de presión, y un semáforo de alertas para saber cuándo frenar, cuándo insistir y cuándo pedir ayuda profesional.',
  tags: ['Maduración y carga', 'Nutrición y descanso', 'Manejo emocional', 'Semáforo de alertas']
}];
export const bonuses = [{
  number: 'Bono 01',
  title: 'EL MANUAL DEL AGENTE Y EL CONTRATO PERFECTO',
  description: 'Plantillas y checklist para revisar contratos: qué preguntar, qué evidencia pedir, qué banderas rojas detectar y cómo documentar todo antes de firmar.',
  originalPrice: 'US$ 13'
}, {
  number: 'Bono 02',
  title: 'PRUEBAS, BECAS Y OPORTUNIDADES INTERNACIONALES',
  description: 'Pasos prácticos para grabar, seleccionar y estructurar videos de forma profesional, además de una estructura de CV deportivo para un contacto efectivo.',
  originalPrice: 'US$ 13'
}];
export const offerChecklist = ['5 módulos completos', 'Más de 200 páginas en PDF', 'El Triángulo de Blindaje: Legalidad, Biología y Visibilidad', 'El manual del agente y el contrato perfecto', 'Pruebas, becas y oportunidades internacionales', 'Acceso inmediato de por vida'];
export const testimonials = [{
  initials: 'AM',
  color: '#1d4ed8',
  quote: 'Una academia nos hizo una oferta y por primera vez pude evaluarla con criterio: qué pedir por escrito, qué verificar y qué dejar en pausa.',
  name: 'Alejandro M.',
  role: 'Papá de futbolista sub-16'
}, {
  initials: 'CR',
  color: '#b45309',
  quote: 'Nos contactó un representante que no pudimos verificar. Con las listas del método frenamos a tiempo y evitamos un compromiso que no nos convenía.',
  name: 'Carolina R.',
  role: 'Mamá de futbolista sub-15'
}, {
  initials: 'PS',
  color: '#15803d',
  quote: 'Antes de firmar, revisamos el documento con las preguntas del módulo de contratos y llevamos las dudas a un abogado. Firmamos con mucha más claridad.',
  name: 'Patricia S.',
  role: 'Mamá de futbolista juvenil'
}, {
  initials: 'JQ',
  color: '#7e22ce',
  quote: 'Armamos el video y el CV deportivo siguiendo la guía y organizamos los torneos del año. Hoy tenemos una estrategia de visibilidad, no improvisación.',
  name: 'Julio Q.',
  role: 'Papá de futbolista sub-17'
}, {
  initials: 'MV',
  color: '#be123c',
  quote: 'Estábamos explorando torneos y una posible ruta hacia otra liga. El método nos ordenó los tiempos, los requisitos y las preguntas correctas.',
  name: 'Mónica V.',
  role: 'Mamá de futbolista sub-18'
}];
export const faqs = [{
  question: '¿Sirve si recién empiezo a entender el mundo del fútbol juvenil?',
  answer: 'Sí, está pensado exactamente para eso. Explica todo desde cero, con lenguaje claro, sin tecnicismos y con ejemplos prácticos.'
}, {
  question: '¿Para qué categorías o edades sirve?',
  answer: 'Está orientado a padres y madres de futbolistas desde las categorías infantiles hasta las juveniles y la firma del primer contrato profesional.'
}, {
  question: '¿Aplica en mi país?',
  answer: 'Los principios de legalidad, visibilidad y desarrollo se explican de forma general. Los procedimientos específicos cambian según el país, por eso el material te indica siempre verificar con la federación correspondiente y con la normativa vigente.'
}, {
  question: '¿Es un producto físico o digital?',
  answer: '100% digital en PDF. No hay envíos. Puedes leerlo desde cualquier dispositivo.'
}, {
  question: '¿Cómo recibo mi compra?',
  answer: 'Inmediatamente después del pago recibes un correo con el enlace de descarga.'
}, {
  question: '¿Tengo que pagar todos los meses?',
  answer: 'No. Es un pago único con acceso de por vida.'
}, {
  question: '¿Qué pasa si no estoy satisfecho?',
  answer: 'Tienes 7 días de garantía. Escribe a solucionesoinformacion@gmail.com.'
}, {
  question: '¿En qué se diferencia de buscar información gratis en internet?',
  answer: 'La información en línea está dispersa, muchas veces desactualizada y rara vez aplica a tu contexto. Este método está organizado, ordenado por etapas y listo para usar cuando aparece una decisión.'
}, {
  question: '¿Esto reemplaza a un abogado?',
  answer: 'No. Este material es educativo y no reemplaza la asesoría de un abogado especializado en derecho deportivo. Te ayuda a entender el proceso, hacer mejores preguntas y saber cuándo consultar con un profesional especializado antes de firmar.'
}, {
  question: '¿Garantiza que mi hijo o hija llegue a ser profesional?',
  answer: 'No, y desconfía de quien lo prometa. Lo que ofrece es más claridad, mejores decisiones, menos riesgo y más control de la familia sobre el proceso.'
}];
export const comparisonRows = [{
  situation: 'Entender cómo funciona el sistema',
  without: 'Confusión y datos sueltos',
  with: 'Un mapa claro de clubes, federaciones y agentes'
}, {
  situation: 'Oferta de una academia o club',
  without: 'Aceptas sin saber qué estás cediendo',
  with: 'Sabes qué preguntar y qué pedir por escrito'
}, {
  situation: 'Te contacta un representante',
  without: 'No puedes verificar si está habilitado',
  with: 'Lista de verificación paso a paso lista para usar'
}, {
  situation: 'Antes de firmar un documento',
  without: 'Firmas sin entender las cláusulas',
  with: 'Revisas los puntos críticos y consultas a tiempo'
}, {
  situation: 'Invitación a una prueba fuera del país',
  without: 'No distingues una oportunidad real de una estafa',
  with: 'Criterios claros para evaluarla con calma'
}, {
  situation: 'Visibilidad ante scouts',
  without: 'Sin video, sin CV deportivo, sin plan',
  with: 'Video, CV deportivo y calendario de torneos armados'
}, {
  situation: 'Presión y desgaste emocional',
  without: 'La familia suma tensión sin darse cuenta',
  with: 'Sabes cómo acompañar sin presionar'
}];
